import Vue from 'vue'
import VuetableFieldCheckbox from 'vuetable-2/src/components/VuetableFieldCheckbox.vue'
import VuetableFieldSequence from "vuetable-2/src/components/VuetableFieldSequence.vue";
import numeral from 'numeral'
import i18n from '@/plugins/i18n';

function formatNumber(value) {
    return numeral(value).format("0,0");
}

function formatNumberDigit(value) {
    return numeral(value).format("0,0.00");
}

export default [
    {
        name: "ch",
        title: i18n.t('Ch.'),
        width: "60px",
        dataClass: "vertical-align-top text-left"
    },
    {
        name: 'image',
        title: i18n.t('Image'),
        width: "60px",
        dataClass: "vertical-align-top text-left"
    },
    {
        name: 'product_name',
        title: i18n.t('Product Name'),
        width: "400px",
        dataClass: "vertical-align-top text-left"
    },

    {
      id: 'warehouse_name',
      name: 'warehouse_name',
      title: i18n.t('Warehouse'),
      dataClass: "vertical-align-top text-left"
    },
    {
      id: 'stock_0_30',
      name: 'stock_0_30',
      title: '0-30 ' + i18n.t('Days'),
      dataClass: "vertical-align-top text-left",
      formatter: (data) => {
        return formatNumber(data);
      }
    },
    {
      id: 'stock_30_60',
      name: 'stock_30_60',
      title: '31-60 ' + i18n.t('Days'),
      dataClass: "vertical-align-top text-left",
      formatter: (data) => {
        return formatNumber(data);
      }
    },
    {
      id: 'stock_60_90',
      name: 'stock_60_90',
      title: '61-90 ' + i18n.t('Days'),
      dataClass: "vertical-align-top text-left",
      formatter: (data) => {
        return formatNumber(data);
      }
    },
    {
      id: 'stock_90_120',
      name: 'stock_90_120',
      title: '91-120 ' + i18n.t('Days'),
      dataClass: "vertical-align-top text-left",
      formatter: (data) => {
        return formatNumber(data);
      }
    },
    {
      id: 'stock_120_plus',
      name: 'stock_120_plus',
      title: i18n.t('More Than 120 Days'),
      dataClass: "vertical-align-top text-left",
      formatter: (data) => {
        return formatNumber(data);
      }
    }
];




// WEBPACK FOOTER //
// ./src/components/tenancy/admin/report/assets/js/FieldStockAging.js